export default __webpack_public_path__ + "static/media/lorry.9a995fc5.png";